/**
 * Fonction pour gérer l'édition d'un nœud
 * Convertit les IDs visuels en IDs de routing et ouvre le panel d'édition
 */
export const createHandleEditNode = (
  setEditingNode,
  setIsPanelOpen,
  callFlowData
) => {
  return (nodeId) => {
    // Convertir les IDs visuels en IDs de routing
    let routingIdToEdit = nodeId;
    
    // Pour les nœuds créés par drag & drop (disconnect, queue, transfer)
    // on doit trouver le routing correspondant dans callFlowData
    if (nodeId?.startsWith('queue-') || 
        nodeId?.startsWith('transfer-user-') || 
        nodeId?.startsWith('transfer-pstn-') || 
        nodeId === 'disconnect-node') {
      
      // Chercher le routing correspondant
      let foundRoutingKey = null;
      
      if (callFlowData?.routing) {
        Object.entries(callFlowData.routing).forEach(([key, routing]) => {
          // Pour disconnect
          if (nodeId === 'disconnect-node' && routing.type === 'disconnect' && !foundRoutingKey) {
            foundRoutingKey = key;
          }
          // Pour queue
          if (nodeId.startsWith('queue-')) {
            const queueId = nodeId.replace('queue-', '');
            if (routing.type === 'queue' && routing.queueId === queueId) {
              foundRoutingKey = key;
            }
          }
          // Pour transfer user
          if (nodeId.startsWith('transfer-user-')) {
            const userId = nodeId.replace('transfer-user-', '');
            if (routing.type === 'transfer' && routing.targetType === 'user' && routing.targetId === userId) {
              foundRoutingKey = key;
            }
          }
          // Pour transfer phone
          if (nodeId.startsWith('transfer-pstn-')) {
            const phoneId = nodeId.replace('transfer-pstn-', '');
            if (routing.type === 'transfer' && routing.targetType === 'phone' && routing.targetId === phoneId) {
              foundRoutingKey = key;
            }
          }
        });
      }
      
      if (foundRoutingKey) {
        routingIdToEdit = `routing-${foundRoutingKey}`;
      } else {
        return;
      }
    }
    
    // Extraire le type de nœud de l'ID (ex: "greeting-1234567890" -> "greeting")
    let nodeType = routingIdToEdit;
    
    // IDs avec tirets qui sont des types de nœuds valides
    const validNodeTypes = ['resource-account', 'open-hours'];
    
    // IDs qui commencent par "routing-" sont des nœuds routing
    if (routingIdToEdit.startsWith('routing-')) {
      nodeType = routingIdToEdit; // Garder l'ID complet pour routing
    } else if (routingIdToEdit.includes('-') && !validNodeTypes.includes(routingIdToEdit)) {
      // Pour les autres IDs avec timestamp, extraire le type
      nodeType = routingIdToEdit.split('-')[0];
    }
    
    const nodeToEdit = { id: nodeType };
    setEditingNode(nodeToEdit);
    setIsPanelOpen(true);
  };
};
